module.exports = __webpack_public_path__ + "media/images/site/CVESTIBULAR_ESTRUTURA_MAIS_COMPLETA-16ab932ee466e27890e215cd2eb20926.jpg";